export default [
  {
    path: '/cursos/criar',
    name: 'Novo Curso',
    component: () => import('./CreateCourse.vue'),
    meta: {
      pageSection: 'Cursos',
      pageTitle: 'Cadastrar cursos',
    },
  },
]
